import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=644323e0"
import script from "./FormDesign.vue?vue&type=script&lang=js"
export * from "./FormDesign.vue?vue&type=script&lang=js"
import style0 from "./FormDesign.vue?vue&type=style&index=0&id=644323e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports